<div class="input-wrapper" [formGroup]="formGroup || null">
  <div class="search-container">
    <div class="input-container">
      <div class="field-group">
        <p-autoComplete
          id="search-address-input"
          [formControlName]="fieldConfig.name"
          [suggestions]="searchAddressResults$ | async"
          field="displayName"
          placeholder="Entrez une adresse"
          [minLength]="3"
          [dropdown]="true"
          [virtualScroll]="true"
          [forceSelection]="false"
          [emptyMessage]="'Aucune adresse trouvée'">
        </p-autoComplete>
        @if (formGroup?.get(fieldConfig.name)?.invalid && formGroup?.get(fieldConfig.name)?.touched) {
          <div class="error-message">
            <app-input-field-error [submitted]="submitted" [control]="formGroup.get(fieldConfig.name)" [fieldName]="fieldConfig.name" />
          </div>
        }
      </div>
    </div>
  </div>
</div>
